import { ecomRequiredApps } from './data/ecom-required-apps.js';
import backendEventsSlugMap from './data/backend-events-slug-map.json' with { type: 'json' };

export const getEcomRequiredApps = async () => {
  return ecomRequiredApps;
};

// This is a temporary workaround until devcenter will support kafkaEventTypes as the id instead of slugs.
export const getBackendEventSlug = async (slug: string) => {
  const backendEventSlug = (
    backendEventsSlugMap as unknown as Record<string, string>
  )[slug];
  return backendEventSlug ? backendEventSlug : slug;
};
